import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-home\"><path d=\"M142.6944 301.2608l296.192-197.7344a122.88 122.88 0 0 1 136.448 0l296.96 197.8368a122.88 122.88 0 0 1 54.784 102.4V803.84a122.88 122.88 0 0 1-122.88 122.88H210.7904a122.88 122.88 0 0 1-122.88-122.88V403.5584a122.88 122.88 0 0 1 54.784-102.2976zM149.504 803.84a61.44 61.44 0 0 0 61.44 61.44h593.5104a61.44 61.44 0 0 0 61.44-61.44V403.6608a61.44 61.44 0 0 0-27.392-51.2L541.2864 154.624a61.44 61.44 0 0 0-68.3008 0L176.8448 352.3584a61.44 61.44 0 0 0-27.392 51.2V803.84z\" p-id=\"1319\" /><path d=\"M397.2096 640.4096c119.296 101.376 235.52 4.4544 240.64 0a30.72 30.72 0 1 1 40.192 46.4896 262.2976 262.2976 0 0 1-164.352 60.8768c-49.408 0-103.68-15.9744-156.2624-60.672a30.7712 30.7712 0 0 1 39.7824-46.848v0.1536z\" p-id=\"1320\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 41